import { Col, Input, message, Row, Upload } from "antd";
import Checkbox from "antd/lib/checkbox/Checkbox";
import React, { FC, useEffect, useState } from "react";
import InputField from "../../../../../shared/components/InputField";
import { QuestionType } from "../index";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import UploadIcon from "../../../../../assets/icons/upload.svg";
import "./question.scss";
import ButtonComponent from "../../../../../shared/components/ButtonComponent";
import QuestionService from "../../../../../services/QuestionService/Question.service";
import { RouteComponentProps, withRouter } from "react-router";
import { ExamExerciseQuestionService } from "../../../../../services/ExamService/ExerciseService/question.service";
import { PreviousPaperService } from "../../../../../services/ExamService/PreviousPaperService/previouspaper.service";
import { PreviousPaperQuestionsModel } from "../../../../../models/ExamModels/PreviousPaperModel/previouspaper.model";
import { serialize } from "serializr";
import { convertJSONToFormData } from "../../../../../shared/utils/converJsonToFormData";
import AddReferenceContent from "../../../../../shared/components/AddReferenceContent";
import {
  ContentLibraryModel,
  ContentLibraryQuestionModel,
} from "../../../../../models/ContentLibraryModel/contentLibrary.model";
import ReferenceContentList from "./ReferenceContentList";
import ContentLibraryService from "../../../../../services/ContentLibraryService/contentLibrary.service";
import {
  QuestionImageOptionAttachmentModel,
} from "../../../../../models/ExerciseModal/Question.model";
import DropdownField from "../../../../../shared/components/DropdownField";
import CKEditorComponent from "../../../../../shared/components/CKEditorComponent";
import QuestionAttachment from "../../../../../shared/components/QuestionAttachment";

interface QuestionProps extends RouteComponentProps {
  index: number;
  value: QuestionType | any;
  deleteIndex: any;
  exerciseId: number | string | undefined;
  setFieldValue: (key: string, value: any) => void;
  onCreate?: (quesiton: any, index: number) => void;
  showFreeText?: boolean;
  showAttachment?: boolean;
}

function beforeUpload(file: any) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
}

const Question: FC<QuestionProps> = ({
  index,
  value,
  setFieldValue,
  exerciseId,
  deleteIndex,
  onCreate,
  location,
  showAttachment = false,
  showFreeText = true,
}) => {
  const [questionId, setQuestionId] = useState();
  const [loading, setLoading] = useState(false);
  const [buttonLoader, setButtonLoader] = useState<boolean>(false);
  const [showReferenceContent, setReferenceContentVisibility] =
    useState<boolean>(false);
  const [referenceContents, setReferenceContents] = useState<
    ContentLibraryModel[]
  >([]);
  const [latex, setLatex] = useState("");
  const [correctAnswerOptions, setCorrectAnswerOptions] = useState<any[]>([]);

  useEffect(() => {
    let options: any = [];
    for (const field in value) {
      if (
        (field.includes("option") || field.includes("image_option")) &&
        value[field]
      ) {
        options.push({
          value: field,
          label: `Option ${field.charAt(field.length - 1)}`,
        });
      }
    }
    setCorrectAnswerOptions(options);
  }, [value]);

  function getBase64(img: any, callback: (data: any) => void) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }
  const handleChange = (info: any) =>
    getBase64(info.file.originFileObj, (imageUrl: any) => {
      setFieldValue(`questions[${index}]attachment`, info.file.originFileObj);
      setFieldValue(`questions[${index}]imageUrl`, imageUrl);
    });
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <img src={UploadIcon} />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const handleQuestionAttachment = (imageFile: any) => {
    if (location.pathname.includes("content-library")) {
      const jsonData = {
        content_question_attachment: {
          image: imageFile,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createContentQuestionAttachment(
        formData,
        (attachment) => {
          let attachments = value?.questionAttachments;
          attachments.push(attachment);
          setFieldValue(`questions[${index}]questionAttachments`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    } else if (
      location.pathname.includes("exams") &&
      location.pathname.includes("previous_paper")
    ) {
      const jsonData = {
        paper_question_attachment: {
          image: imageFile,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createPaperQuestionAttachment(
        formData,
        (attachment) => {
          let attachments = value?.questionAttachments;
          attachments.push(attachment);
          setFieldValue(`questions[${index}]questionAttachments`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    } else if (location.pathname.includes("exams")) {
      const jsonData = {
        exam_question_attachment: {
          image: imageFile,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createExamQuestionAttachment(
        formData,
        (attachment) => {
          let attachments = value?.questionAttachments;
          attachments.push(attachment);
          setFieldValue(`questions[${index}]questionAttachments`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    } else {
      const jsonData = {
        question_attachment: {
          image: imageFile,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createQuestionAttachment(
        formData,
        (attachment) => {
          let attachments = value?.questionAttachments;
          attachments.push(attachment);
          setFieldValue(`questions[${index}]questionAttachments`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    }
  };
  const handleSolutionAttachment = (imageFile: any) => {
    if (location.pathname.includes("content-library")) {
      const jsonData = {
        cont_quest_sol_atchmnt: {
          image: imageFile,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createContentSolutionAttachment(
        formData,
        (attachment) => {
          let attachments = value?.questionSolutionAttachments;
          attachments.push(attachment);
          setFieldValue(`questions[${index}]questionSolutionAttachments`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    } else if (
      location.pathname.includes("exams") &&
      location.pathname.includes("previous_paper")
    ) {
      const jsonData = {
        paper_question_solution_attachment: {
          image: imageFile,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createPaperSolutionAttachment(
        formData,
        (attachment) => {
          let attachments = value?.questionSolutionAttachments;
          attachments.push(attachment);
          setFieldValue(`questions[${index}]questionSolutionAttachments`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    } else if (location.pathname.includes("exams")) {
      const jsonData = {
        exam_question_solution_attachment: {
          image: imageFile,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createExamSolutionAttachment(
        formData,
        (attachment) => {
          let attachments = value?.questionSolutionAttachments;
          attachments.push(attachment);
          setFieldValue(`questions[${index}]questionSolutionAttachments`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    } else {
      const jsonData = {
        question_solution_attachment: {
          image: imageFile,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createSolutionAttachment(
        formData,
        (attachment) => {
          let attachments = value?.questionSolutionAttachments;
          attachments.push(attachment);
          setFieldValue(`questions[${index}]questionSolutionAttachments`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    }
  };
  const handleOptionAttachment = (
    imageFile: any,
    option: string,
    no: number
  ) => {
    if (location.pathname.includes("content-library")) {
      const jsonData = {
        cont_quest_option_image: {
          image: imageFile,
          option: option,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createContentQuestionImageOptionAttachment(
        formData,
        (attachment) => {
          let attachments = value.questionOptionImages;
          attachments.push(attachment);
          setFieldValue(
            `questions[${index}]image_option${no}`,
            attachment.questionOptionImageUrl
          );
          setFieldValue(`questions[${index}]questionOptionImages`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    } else if (
      location.pathname.includes("exams") &&
      location.pathname.includes("previous_paper")
    ) {
      const jsonData = {
        paper_exam_question_option_image: {
          image: imageFile,
          option: option,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createPaperQuestionImageOptionAttachment(
        formData,
        (attachment) => {
          let attachments = value.questionOptionImages;
          attachments.push(attachment);
          setFieldValue(
            `questions[${index}]image_option${no}`,
            attachment.questionOptionImageUrl
          );
          setFieldValue(`questions[${index}]questionOptionImages`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    } else if (location.pathname.includes("exams")) {
      const jsonData = {
        exam_question_option_image: {
          image: imageFile,
          option: option,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createExamQuestionImageOptionAttachment(
        formData,
        (attachment) => {
          let attachments = value.questionOptionImages;
          attachments.push(attachment);
          setFieldValue(
            `questions[${index}]image_option${no}`,
            attachment.questionOptionImageUrl
          );
          setFieldValue(`questions[${index}]questionOptionImages`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    } else {
      const jsonData = {
        question_option_image: {
          image: imageFile,
          option: option,
        },
      };
      const formData = convertJSONToFormData(jsonData);
      QuestionService.createQuestionImageOptionAttachment(
        formData,
        (attachment) => {
          let attachments = value.questionOptionImages;
          attachments.push(attachment);
          setFieldValue(
            `questions[${index}]image_option${no}`,
            attachment.questionOptionImageUrl
          );
          setFieldValue(`questions[${index}]questionOptionImages`, [
            ...attachments,
          ]);
        },
        () => {}
      );
    }
  };

  const handleDeleteOptions = (option: string) => {
    let index = value.questionOptionImages.findIndex(
      (data: QuestionImageOptionAttachmentModel) => data.option === option
    );
    let optionImages = value.questionOptionImages;
    optionImages.splice(index, 1);
    setFieldValue("questionOptionImages", [...optionImages]);
  };

  const handleQuestion = () => {
    console.log(value);
    if (
      location.pathname.includes("exams") &&
      location.pathname.includes("previous_paper")
    ) {
      value["isActive"] = true;
      value["paperId"] = exerciseId;

      if (value["noOptions"]) {
        value["onlyFreeText"] = true;
        delete value["correctAnswer"];
        delete value["option1"];
        delete value["option2"];
        delete value["option3"];
      }

      const serializeData = serialize(PreviousPaperQuestionsModel, value);
      const payload = {
        paper_question: serializeData,
      };

      if (!value.id) {
        PreviousPaperService.createPaperQuestion(
          payload,
          (question) => {
            setQuestionId(question?.id as any);
            onCreate && onCreate(question, index);
          },
          () => {}
        );
      } else {
        PreviousPaperService.updatePaperQuestion(
          value.id,
          payload,
          (question) => {
            console.log(question);
            setQuestionId(question?.id as any);
            onCreate && onCreate(question, index);
          },
          () => {}
        );
      }
    } else if (location.pathname.includes("content-library")) {
      value["isActive"] = true;
      value["contentLibraryId"] = exerciseId;

      if (value["noOptions"]) {
        value["onlyFreeText"] = true;
        delete value["correctAnswer"];
        delete value["option1"];
        delete value["option2"];
        delete value["option3"];
      }

      const serializeData = serialize(ContentLibraryQuestionModel, value);
      console.log(serializeData);
      const payload = {
        content_question: { ...serializeData, attachment: value["attachment"] },
      };

      if (!value.id) {
        ContentLibraryService.createContentQuestion(
          payload,
          (question: any) => {
            console.log(question);
            setQuestionId(question?.id as any);
            onCreate && onCreate(question, index);
          },
          () => {},
          () => {}
        );
      } else {
        ContentLibraryService.updateContentQuestion(
          value?.id,
          payload,
          (question: any) => {
            console.log(question);
            setQuestionId(question?.id as any);
            onCreate && onCreate(question, index);
          },
          () => {},
          () => {}
        );
      }
    } else if (location.pathname.includes("exams")) {
      value["attachment"] = {
        originalFilename: value["attachment"]?.name,
        tempfile: value["attachment"]?.uid,
        contentType: value["attachment"]?.type,
      };
      value["isActive"] = true;
      value["exerciseId"] = exerciseId;

      if (value["noOptions"]) {
        value["onlyFreeText"] = true;

        delete value["correctAnswer"];
        delete value["option1"];
        delete value["option2"];
        delete value["option3"];
      }
      if (!value.id) {
        ExamExerciseQuestionService.createExamExerciseQuestion(
          {
            ...value,
            exerciseId,
          },
          (question) => {
            setQuestionId(question?.exerciseId as any);
            onCreate && onCreate(question, index);
          },
          () => {},
          () => {}
        );
      } else {
        ExamExerciseQuestionService.updateExamExerciseQuestion(
          value?.id,
          {
            ...value,
            exerciseId,
          },
          (question) => {
            setQuestionId(question?.exerciseId as any);
            onCreate && onCreate(question, index);
          },
          () => {},
          () => {}
        ).then();
      }
    } else {
      value["attachment"] = {
        originalFilename: value["attachment"]?.name,
        tempfile: value["attachment"]?.uid,
        contentType: value["attachment"]?.type,
      };
      value["isActive"] = true;
      value["exerciseId"] = exerciseId;

      if (value["noOptions"]) {
        value["onlyFreeText"] = true;

        delete value["correctAnswer"];
        delete value["option1"];
        delete value["option2"];
        delete value["option3"];
      }
      if (!value.id) {
        QuestionService.createQuestion(
          {
            ...value,
            exerciseId,
          },
          (question) => {
            console.log(question);
            setQuestionId(question?.id as any);
            onCreate && onCreate(question, index);
          },
          () => {},
          () => {}
        );
      } else {
        QuestionService.updateQuestion(
          value?.id,
          {
            ...value,
            exerciseId,
          },
          (question) => {
            setQuestionId(question?.id as any);
            onCreate && onCreate(question, index);
          },
          () => {},
          () => {}
        ).then();
      }
    }
  };

  return (
    <div className="pj-question-form__container">
      <AddReferenceContent
        visible={showReferenceContent}
        setVisible={setReferenceContentVisibility}
        onClickAdd={(contents) => {
          console.log(contents);
          setReferenceContents(contents);
        }}
      />
      <Row>
        <Col span={24}>
          <CKEditorComponent
            title="Question"
            value={value?.question ?? ""}
            onChange={(data) => {
              setFieldValue(`questions[${index}].question`, data);
            }}
          />
          <QuestionAttachment
            data={value.questionAttachments}
            multipleAttachments
            handleDelete={(index) => {
              let attachments = value.questionAttachments;
              attachments.splice(index, 1);
              setFieldValue(
                `questions[${index}]questionAttachments`,
                attachments
              );
            }}
            onAttach={(value) => {
              console.log(value);
              handleQuestionAttachment(value);
            }}
          />
        </Col>
        {/* <Col span={24}>
          <InputField
            attachment={showAttachment}
            multipleAttachments
            data={value.questionAttachments}
            type="text"
            name={`questions[${index}].question`}
            placeholder="Type question"
            handleDelete={(index) => {
              let attachments = value.questionAttachments;
              attachments.splice(index, 1);
              setFieldValue(
                `questions[${index}]questionAttachments`,
                attachments
              );
            }}
            onAttach={(value) => {
              handleQuestionAttachment(value);
            }}
          />
        </Col> */}
      </Row>
      <Row gutter={[16, 16]} className="mt-4">
        <Col span={24}>
          <CKEditorComponent
            title="Option 1"
            value={value?.option1 ?? ""}
            onChange={(data) =>
              setFieldValue(`questions[${index}].option1`, data)
            }
            disabled={
              value.noOptions ||
              value?.questionOptionImages?.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option1"
              ).length > 0
            }
          />
          <QuestionAttachment
            data={
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option1"
              ).length
                ? value.questionOptionImages.filter(
                    (data: QuestionImageOptionAttachmentModel) =>
                      data.option == "image_option1"
                  )[0]
                : null
            }
            onAttach={(value) => {
              setFieldValue(`questions[${index}].option1`, "");
              handleOptionAttachment(value, "image_option1", 1);
            }}
            handleDelete={() => handleDeleteOptions("image_option1")}
          />
          {/* <div>

            <InputField
              type="text"
              attachment={showAttachment}
              data={
                value.questionOptionImages.filter(
                  (data: QuestionImageOptionAttachmentModel) =>
                    data.option == "image_option1"
                ).length
                  ? value.questionOptionImages.filter(
                      (data: QuestionImageOptionAttachmentModel) =>
                        data.option == "image_option1"
                    )[0]
                  : null
              }
              name={`questions[${index}].option1`}
              placeholder="Type here ..."
              title="Option 1"
              disabled={
                value.noOptions ||
                value.questionOptionImages.filter(
                  (data: QuestionImageOptionAttachmentModel) =>
                    data.option == "image_option1"
                ).length
              }
              onAttach={(value) => {
                setFieldValue(`questions[${index}].option1`, null);
                handleOptionAttachment(value, "image_option1", 1);
              }}
              handleDelete={() => handleDeleteOptions("image_option1")}
            />
          </div> */}
        </Col>
        <Col span={24}>
          <CKEditorComponent
            title="Option 2"
            value={value?.option2 ?? ""}
            onChange={(data) =>
              setFieldValue(`questions[${index}].option2`, data)
            }
            disabled={
              value?.noOptions ||
              value?.questionOptionImages?.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option2"
              ).length > 0
            }
          />
          <QuestionAttachment
            data={
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option2"
              ).length
                ? value.questionOptionImages.filter(
                    (data: QuestionImageOptionAttachmentModel) =>
                      data.option == "image_option2"
                  )[0]
                : null
            }
            onAttach={(value) => {
              setFieldValue(`questions[${index}].option2`, "");

              handleOptionAttachment(value, "image_option2", 2);
            }}
            handleDelete={() => handleDeleteOptions("image_option2")}
          />
          {/* <InputField
            type="text"
            name={`questions[${index}].option2`}
            placeholder="Type here ..."
            data={
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option2"
              ).length
                ? value.questionOptionImages.filter(
                    (data: QuestionImageOptionAttachmentModel) =>
                      data.option == "image_option2"
                  )[0]
                : null
            }
            title="Option 2"
            attachment={showAttachment}
            disabled={
              value.noOptions ||
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option2"
              ).length
            }
            onAttach={(value) => {
              setFieldValue(`questions[${index}].option2`, null);

              handleOptionAttachment(value, "image_option2", 2);
            }}
            handleDelete={() => handleDeleteOptions("image_option2")}
          /> */}
        </Col>
        <Col span={24}>
          <CKEditorComponent
            title="Option 3"
            value={value?.option3 ?? ""}
            onChange={(data) =>
              setFieldValue(`questions[${index}].option3`, data)
            }
            disabled={
              value.noOptions ||
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option3"
              ).length > 0
            }
          />
          <QuestionAttachment
            data={
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option3"
              ).length
                ? value.questionOptionImages.filter(
                    (data: QuestionImageOptionAttachmentModel) =>
                      data.option == "image_option3"
                  )[0]
                : null
            }
            onAttach={(value) => {
              setFieldValue(`questions[${index}].option3`, "");
              handleOptionAttachment(value, "image_option3", 3);
            }}
            handleDelete={() => handleDeleteOptions("image_option3")}
          />
          {/* <InputField
            type="text"
            name={`questions[${index}].option3`}
            data={
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option3"
              ).length
                ? value.questionOptionImages.filter(
                    (data: QuestionImageOptionAttachmentModel) =>
                      data.option == "image_option3"
                  )[0]
                : null
            }
            placeholder="Type here ..."
            title="Option 3"
            attachment={showAttachment}
            disabled={
              value.noOptions ||
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option3"
              ).length
            }
            onAttach={(value) => {
              setFieldValue(`questions[${index}].option3`, null);
              handleOptionAttachment(value, "image_option3", 3);
            }}
            handleDelete={() => handleDeleteOptions("image_option3")}
          /> */}
        </Col>
        <Col span={24}>
          <CKEditorComponent
            title="Option 4"
            value={value?.option4 ?? ""}
            onChange={(data) =>
              setFieldValue(`questions[${index}].option4`, data)
            }
            disabled={
              value.noOptions ||
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option4"
              ).length > 0
            }
          />
          <QuestionAttachment
            data={
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option4"
              ).length
                ? value.questionOptionImages.filter(
                    (data: QuestionImageOptionAttachmentModel) =>
                      data.option == "image_option4"
                  )[0]
                : null
            }
            onAttach={(value) => {
              setFieldValue(`questions[${index}].option4`, "");
              handleOptionAttachment(value, "image_option4", 4);
            }}
            handleDelete={() => handleDeleteOptions("image_option4")}
          />
          {/* <InputField
            type="text"
            attachment={showAttachment}
            name={`questions[${index}].option4`}
            data={
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option4"
              ).length
                ? value.questionOptionImages.filter(
                    (data: QuestionImageOptionAttachmentModel) =>
                      data.option == "image_option4"
                  )[0]
                : null
            }
            placeholder="Type here ..."
            title="Option 4"
            disabled={
              value.noOptions ||
              value.questionOptionImages.filter(
                (data: QuestionImageOptionAttachmentModel) =>
                  data.option == "image_option4"
              ).length
            }
            onAttach={(value) => {
              setFieldValue(`questions[${index}].option4`, null);
              handleOptionAttachment(value, "image_option4", 4);
            }}
            handleDelete={() => handleDeleteOptions("image_option4")}
          /> */}
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <div className="question-form__label">Correct answer</div>
          <DropdownField
            name={`questions[${index}].correctAnswer`}
            placeholder="Select correct answer"
            options={correctAnswerOptions}
            value={value.correctAnswer}
            showSearch={false}
            onChange={(value: any) =>
              setFieldValue(`questions[${index}].correctAnswer`, value)
            }
            optionFilterProp="label"
            className="options__dropdown"
          />
        </Col>
      </Row>

      {showFreeText && (
        <Row className="question__no-options mt-4">
          <Checkbox
            value={value?.noOptions}
            onChange={({ target: { checked } }) => {
              setFieldValue(`questions[${index}].noOptions`, checked);
            }}
          />{" "}
          &nbsp;&nbsp; No options. Only free text
        </Row>
      )}

      <Row className="mt-4">
        <Col span={24}>
          <CKEditorComponent
            title="Solution"
            value={value?.solution ?? ""}
            onChange={(data) =>
              setFieldValue(`questions[${index}].solution`, data)
            }
          />
          <QuestionAttachment
            multipleAttachments
            data={value.questionSolutionAttachments}
            handleDelete={(index) => {
              let attachments = value.questionSolutionAttachments;
              attachments.splice(index, 1);
              setFieldValue(
                `questions[${index}]questionSolutionAttachments`,
                attachments
              );
            }}
            onAttach={(value) => {
              handleSolutionAttachment(value);
            }}
          />

          {/* <InputField
            type="text"
            attachment={showAttachment}
            name={`questions[${index}].solution`}
            placeholder="Type here ..."
            title="Solution"
            multipleAttachments
            data={value.questionSolutionAttachments}
            handleDelete={(index) => {
              let attachments = value.questionSolutionAttachments;
              attachments.splice(index, 1);
              setFieldValue(
                `questions[${index}]questionSolutionAttachments`,
                attachments
              );
            }}
            onAttach={(value) => {
              handleSolutionAttachment(value);
            }}
          /> */}
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div
            className="add-reference__content"
            onClick={() => setReferenceContentVisibility(true)}
          >
            +&nbsp;&nbsp;Add Reference Content
          </div>
          {referenceContents.length ? (
            <ReferenceContentList
              onRemove={(index) => {
                let data = referenceContents;
                data.splice(index, 1);
                setReferenceContents([...data]);
              }}
              contents={referenceContents}
            />
          ) : (
            <div />
          )}
        </Col>
      </Row>
      <Row className="question__solution__control">
        {!showAttachment && (
          <Col span={12}>
            <Upload
              name="avatar"
              listType="picture-card"
              showUploadList={false}
              beforeUpload={beforeUpload}
              onChange={handleChange}
            >
              {value.imageUrl ? (
                <img
                  src={value.imageUrl}
                  alt="avatar"
                  style={{ width: "100%" }}
                />
              ) : (
                uploadButton
              )}
            </Upload>
          </Col>
        )}
        <Col span={12} className="btn-submit">
          <ButtonComponent
            buttonContent="Submit"
            type="primary"
            onClick={handleQuestion}
          />
        </Col>
      </Row>
    </div>
  );
};

export default withRouter(Question);
